import styled from '@emotion/styled'
import { FlexColumn } from '@core/commonStyles'

export const Content = styled(FlexColumn)`
    gap: 16px;
    flex: 1;
    width: 100%;
    padding: 24px;
    min-height: 320px;
    align-items: center;
    justify-content: center;

    & svg {
        width: 72px;
        height: 72px;
    }
`
